(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }



  // List view logic

  /* --- List View Toggle Logic --- */
  document.addEventListener('DOMContentLoaded', () => {
    function initViewToggle() {
      const container = document.querySelector('.collection-wrapper');
      const radios = document.querySelectorAll('.js-view-option');

      // 1. Check LocalStorage and apply
      const saved = localStorage.getItem('collection-layout-pref');
      if (saved === 'list' && container) {
        container.setAttribute('data-view-mode', 'list');
        // Visually check the list radio button if it exists
        const listRadio = document.querySelector('input[value="list"].js-view-option');
        if(listRadio) listRadio.checked = true;
      }

      // 2. Add Listeners to Radio Buttons
      radios.forEach(radio => {
        radio.addEventListener('change', (e) => {
          const val = e.target.value;
          localStorage.setItem('collection-layout-pref', val);
          
          if (val === 'list') {
            container.setAttribute('data-view-mode', 'list');
          } else {
            container.removeAttribute('data-view-mode');
          }
        });
      });
    }

    initViewToggle();

    // 3. Handle AJAX Reloads (Filters)
    // When filters change, Shopify replaces the DOM. We need to re-apply the class.
    const observer = new MutationObserver((mutations) => {
       const container = document.querySelector('.collection-wrapper');
       if(container && localStorage.getItem('collection-layout-pref') === 'list') {
          // If the attribute is missing after reload, add it back
          if(!container.hasAttribute('data-view-mode')){
             container.setAttribute('data-view-mode', 'list');
             
             // Also re-check the radio button
             const listRadio = document.querySelector('input[value="list"].js-view-option');
             if(listRadio) listRadio.checked = true;
          }
       }
    });
    
    // Watch the results-list element for changes
    const wrapper = document.querySelector('results-list');
    if(wrapper) observer.observe(wrapper, { childList: true, subtree: true });
  });




  


  } catch(e) { console.error(e); }
})();
})();
